import request from './base/api';
import { getMemberId } from '@/store/utils/member';

export function fetchMemberLastProgram(cb, errCb) {
  let member_id = getMemberId();

  const config = {
    params: {
      member_id
    }
  };

  return request({
    url: 'member/last-program',
    method: 'get',
    cb,
    errCb,
    config
  });
}

export function fetchPrograms({ branch_id }, cb, errCb) {
  const config = {
    params: {
      branch_id
    }
  };

  return request({
    url: 'programs',
    method: 'get',
    cb,
    errCb,
    config
  });
}

export function fetchProgram({ programId }, cb, errCb) {
  return request({
    url: 'programs/' + programId,
    method: 'get',
    cb,
    errCb
  });
}

export default {
  fetchMemberLastProgram,
  fetchPrograms,
  fetchProgram
};
